import { TableContainer } from '@material-ui/core'

import styled from 'styled-components'

export const TableWrapper = styled(TableContainer)`
	height: 530px;
`
